'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)("div.dropzone").each(function () {
        var dropzone = (0, _jquery2.default)(this).get(0).dropzone;
        if (dropzone) {
            dropzone.on('error', function () {
                setTimeout(sweetAlert({
                    text: Resx.Messages.FileNotUploaded,
                    type: 'warning',
                    title: Resx.Common.Warning,
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: Resx.Common.Confirm
                }, function () {}), 50);
            });
        }
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('App', 'Messages', 'Common');

;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/initializers/dropzoneError.js
// module id = 930
// module chunks = 0